import React, { Component } from 'react';
import IconWrapper from './IconWrapper';

const IconItem = (props) => {
	const color = props.color || '#3497da'

	return (
		<IconWrapper {...props} >
			<svg
				width="17"
				height="16"
				viewBox="0 0 17 16"
				xmlns="http://www.w3.org/2000/svg"
				role="img"
			>
				<g transform="translate(0,0) scale(0.025)">
					<path
						d="M384 64C366.3 64 352 78.3 352 96C352 113.7 366.3 128 384 128L466.7 128L265.3 329.4C252.8 341.9 252.8 362.2 265.3 374.7C277.8 387.2 298.1 387.2 310.6 374.7L512 173.3L512 256C512 273.7 526.3 288 544 288C561.7 288 576 273.7 576 256L576 96C576 78.3 561.7 64 544 64L384 64zM144 160C99.8 160 64 195.8 64 240L64 496C64 540.2 99.8 576 144 576L400 576C444.2 576 480 540.2 480 496L480 416C480 398.3 465.7 384 448 384C430.3 384 416 398.3 416 416L416 496C416 504.8 408.8 512 400 512L144 512C135.2 512 128 504.8 128 496L128 240C128 231.2 135.2 224 144 224L224 224C241.7 224 256 209.7 256 192C256 174.3 241.7 160 224 160L144 160z"
						fill={color}
					/>
				</g>
			</svg>

		</IconWrapper>
	)
}

export default IconItem